<template>
  <main class="setting-wizard">
    <div class="setting-wizard__left">
      <h1>+Hubへようこそ</h1>
      <p>
        様々な用途で利用しているロボットの設定・コントロールを一つにまとめて
        、日々の運用は+Hubで簡潔にしましょう。
      </p>
      <button @click="onClickRoute($event, 'GeneralSetting')">スタート</button>
      <a href="https://usersite.plus-hub.com" target="_blank" rel="noopener noreferrer"><span>?</span>より詳細なヘルプページ</a>
    </div>
    <div class="setting-wizard__right">
      <h1>
        +Hub BASEで管理がつながる
        <img src="../assets/images/icon_home.svg" />
      </h1>
      <img src="../assets/images/wizard_first.svg" />
    </div>
  </main>
</template>
<script>
import RouterUtils from '../_helpers/router.util'
import { mapState, mapActions } from 'vuex'
import { SettingWizardStep } from '../enums/setting-wizard-step.enums'
export default {
  computed: {
    ...mapState('auth', ['user'])
  },
  mounted() {
    this.updateMenuStatus(0)
  },
  methods: {
    ...mapActions('settingWizardStore', ['updateSetupData', 'updateMenuStatus']),
    async onClickRoute(e, routeName) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      // 完了したステップを更新します。
      await this.updateSetupData({hubId: this.user.deptId, step: SettingWizardStep.START_SETUP_STEP})
      RouterUtils.goToRouterName(routeName)
    }
  }
}
</script>

<style lang="scss" scoped>
  .setting-wizard {
    display: flex;
    height: 100vh;
    overflow-y: hidden;
    @include media-breakpoint-default(){
      min-width: $default-responsive-width;
      // -20px (height of scroll)
      height: calc(100vh - 20px);
    }
    &__left {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      width: 400px;
      padding: 40px;
      flex-shrink: 0;
      background-color: #4e66a6;
      h1 {
        @include responsive-fs(28);
        font-weight: 900;
        color: #ffffff;
        margin-bottom: 24px;
        word-break: break-all;
      }
      p {
        @include responsive-fs(18);
        color: #ffffff;
        text-align: stretch;
        margin-bottom: 40px;
        word-break: break-all;
      }
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        @include responsive-fs(18);
        color: #4e66a6;
        font-weight: 700;
        height: 45px;
        width: 100%;
        border: none;
        background: #ffffff;
        border-radius: 4px;
        margin-bottom: 40px;
      }
      a {
        display: flex;
        align-items: center;
        color: #ffffff;
        @include responsive-fs(14);
        &:hover {
          text-decoration: none;
        }
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 16px;
          height: 16px;
          border: 1px solid #ffffff;
          border-radius: 40px;
          margin-right: 4px;
          @include responsive-fs(12);
        }
      }
    }
    &__right {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 40px;
      background-color: #f8f8f8;
      h1 {
        display: flex;
        @include responsive-fs(28);
        padding: 16px 24px;
        background: #ffffff;
        border-radius: 8px;
        position: relative;
        margin-bottom: 40px;
        img {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -30px;
        }
      }
      img {
        max-width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SettingWizardComponent.vue